import script from "./NewChatListContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewChatListContainer.vue?vue&type=script&setup=true&lang=ts"

import "./NewChatListContainer.vue?vue&type=style&index=0&id=1d1392c7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d1392c7"]])

export default __exports__